<template>
    <div class="ship-early__check-inventory mt-small">
        <button @click.stop.prevent="openModal()" type="button" name="shipearly-locator"
                class="btn-black-large btn--full btn--svg-left">
                Check Local Dealer Inventory
        </button>
    </div>
</template>
<script type="text/babel">
export default {
    data() {
        return {}
    },
    mounted() {
        let jsFile = document.createElement('script');
        let cssFile = document.createElement('link');

        cssFile.id = 'shipearly-widgets-css';
        cssFile.rel = 'stylesheet';
        cssFile.href = 'https://' + this.subdomain + '.shipearlyapp.com/widgets/dist/shipearly-widgets.min.css';
        document.head.appendChild(cssFile);

        jsFile.id = 'shipearly-widgets-js';
        jsFile.src = 'https://' + this.subdomain + '.shipearlyapp.com/widgets/dist/shipearly-widgets.min.js';
        document.head.appendChild(jsFile);
    },
    props: ['apiKey', 'subdomain', 'productId'],
    computed: {},
    methods: {
        openModal() {
            ShipEarly.ProductLocator({
                client_id: this.apiKey,
                product_id: this.productId,
            }).render('body', 'modal');
        }
    }
}
</script>
